import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { CABIN_CREW_BUS_ASSIGNMENT_PATH } from '../../../../config/paths';
import CabinCrewBusAssignmentForm from './CabinCrewBusAssignmentForm';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import Content from '../../../layout/Content';
import { clearCabinCrewBusAssignment, getCabinCrewBusAssignment, postCabinCrewBusAssign } from '../../../../actions/traffic/CabinCrewBusAssignment';

export class EditCabinCrewBusAssignment extends Component {
  componentDidMount() {
    const {
      dispatchGetCabinCrewBusAssignment,
      match: {
        params: { id },
      },
    } = this.props;
    dispatchGetCabinCrewBusAssignment({ id });
  }

  componentWillUnmount() {
    const { dispatchClearCabinCrewBusAssignment } = this.props;
    dispatchClearCabinCrewBusAssignment();
  }

  onSubmit = (formValues) => {
    const { dispatchPostCabinCrewBusAssign } = this.props;
    const cabinCrewListLength = formValues.cabinCrewList.length;
    const newFormValues = {
      busId: formValues.bus.value,
      companyBusId: formValues.bus.label,
      cabinCrewId: formValues.cabinCrewList[cabinCrewListLength - 1].cabinCrew.value,
    };
    dispatchPostCabinCrewBusAssign(newFormValues);
  };

  render() {
    const { breadcrumbs, cabinCrewBusAssignment, loading } = this.props;
    let content;

    if (loading) {
      content = <Loader />;
    } else if (cabinCrewBusAssignment.isEmpty()) {
      content = <NoDataResource returnPage={CABIN_CREW_BUS_ASSIGNMENT_PATH} />;
    } else {
      const bus = {
        value: cabinCrewBusAssignment.get('registeredBus').id,
        label: cabinCrewBusAssignment.get('registeredBus').companyBusId,
      };
      content = <CabinCrewBusAssignmentForm onSubmit={this.onSubmit} bus={bus} />;
    }
    return (
      <Content
        breadcrumbs={breadcrumbs}
        title="Editar Asignación de Servicio a Bordo"
        subtitle="Editar asignación de tripulantes"
        content={content}
      />
    );
  }
}

EditCabinCrewBusAssignment.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostCabinCrewBusAssign: PropTypes.func.isRequired,
  dispatchGetCabinCrewBusAssignment: PropTypes.func.isRequired,
  dispatchClearCabinCrewBusAssignment: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  cabinCrewBusAssignment: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditCabinCrewBusAssignment.defaultProps = {
  loading: false,
};

const mapStateToProps = (
  { TrafficUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...TrafficUnit.CabinCrewUnitHome.get('breadcrumbs'),
    {
      text: 'Asignaciones de Servicio a Bordo',
      href: CABIN_CREW_BUS_ASSIGNMENT_PATH,
    },
    {
      text: 'Ver',
      href: `${CABIN_CREW_BUS_ASSIGNMENT_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],
  cabinCrewBusAssignment: TrafficUnit.CabinCrewBusAssignment.getIn([
    'current',
    'content',
  ]),
  loading: !TrafficUnit.CabinCrewBusAssignment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchPostCabinCrewBusAssign: postCabinCrewBusAssign,
  dispatchGetCabinCrewBusAssignment: getCabinCrewBusAssignment,
  dispatchClearCabinCrewBusAssignment: clearCabinCrewBusAssignment,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditCabinCrewBusAssignment);